import React from 'react';
import { ApiTokens as SharedApiTokens } from '@itds/components';
import { Api } from '../utils/Api';

const ApiTokens = () => {
  return <SharedApiTokens api={Api} />;
};

export default ApiTokens;
